'use client';

import { PlasmicComponent } from '@plasmicapp/loader-nextjs';
import { PlasmicErrorBoundary } from './PlasmicErrorBoundary';
import { isPlasmicProviderFailed } from '~/lib/plasmic/plasmic-init-client';
import { ComponentProps } from 'react';

type PlasmicComponentProps = ComponentProps<typeof PlasmicComponent>

interface SafePlasmicComponentProps extends PlasmicComponentProps {
  fallback?: React.ReactNode;
}

/**
 * Safe wrapper around PlasmicComponent that catches errors
 * and prevents them from crashing the app
 */
export function SafePlasmicComponent({
  component,
  componentProps,
  fallback,
}: SafePlasmicComponentProps) {
  // If Plasmic provider failed, don't try to render Plasmic components
  if (isPlasmicProviderFailed()) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Skipping Plasmic component "${component}" because provider failed`);
    }
    return fallback || null;
  }

  return (
    <PlasmicErrorBoundary componentName={component} fallback={fallback}>
      <PlasmicComponent component={component} componentProps={componentProps} />
    </PlasmicErrorBoundary>
  );
}
